import './App.css';
import PhotoOverlay from './components/PhotoOverlay';

function App() {
  return (
    <main className="app-page">
      <PhotoOverlay />
    </main>
  );
}

export default App;
